var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoaderThumbNail = function SvgLoaderThumbNail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50BCBD",
    d: "M53.625 24.375H49.44a21.4 21.4 0 0 0-1.71-4.14l2.948-2.97a3.29 3.29 0 0 0 .99-2.385 3.3 3.3 0 0 0-.99-2.385l-3.173-3.172a3.35 3.35 0 0 0-4.77 0l-2.97 2.97c-1.312-.73-2.7-1.31-4.14-1.733V6.375A3.375 3.375 0 0 0 32.25 3h-4.5a3.375 3.375 0 0 0-3.375 3.375v4.185a20.3 20.3 0 0 0-4.14 1.733l-2.97-2.97a3.35 3.35 0 0 0-4.77 0l-3.172 3.172a3.3 3.3 0 0 0-.99 2.385 3.24 3.24 0 0 0 .99 2.385l2.947 2.97a21.4 21.4 0 0 0-1.71 4.14H6.375A3.375 3.375 0 0 0 3 27.75v4.5a3.375 3.375 0 0 0 3.375 3.375h4.185c.42 1.437.993 2.825 1.71 4.14l-2.947 2.97a3.375 3.375 0 0 0 0 4.77l3.172 3.172a3.44 3.44 0 0 0 4.77 0l2.97-2.947a21 21 0 0 0 4.14 1.71v4.185A3.375 3.375 0 0 0 27.75 57h4.5a3.375 3.375 0 0 0 3.375-3.375V49.44a21 21 0 0 0 4.14-1.71l2.97 2.948a3.35 3.35 0 0 0 4.77 0l3.172-3.173a3.375 3.375 0 0 0 0-4.77l-2.947-2.97a21 21 0 0 0 1.71-4.14h4.185A3.375 3.375 0 0 0 57 32.25v-4.5a3.375 3.375 0 0 0-3.375-3.375M30 41.25a11.25 11.25 0 1 1 0-22.5 11.25 11.25 0 0 1 0 22.5"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    dur: "0.8s",
    from: "0 30 30",
    repeatCount: "indefinite",
    to: "360 30 30",
    type: "rotate"
  }))));
};
export default SvgLoaderThumbNail;